import { DATA_FIELD_KEYS } from '../dataFieldKeys';
import * as CALCULATION_KEY from './calculations';

export const REPORT_COLUMN_KEYS: { [key: string]: string } = {
  eo_click: DATA_FIELD_KEYS.CLICK,
  eo_install: DATA_FIELD_KEYS.INSTALL,
  eo_reinstall: DATA_FIELD_KEYS.REINSTALL,
  eo_open: DATA_FIELD_KEYS.OPEN,
  eo_web_session_start: DATA_FIELD_KEYS.WEB_SESSION_START,
  eo_branch_cta_view: DATA_FIELD_KEYS.BRANCH_CTA_VIEW,
  eo_sms_sent: DATA_FIELD_KEYS.SMS_SENT,
  eo_impression: DATA_FIELD_KEYS.IMPRESSION,
  eo_pageview: DATA_FIELD_KEYS.PAGEVIEW,
  eo_dismissal: DATA_FIELD_KEYS.DISMISSAL,
  cost: DATA_FIELD_KEYS.COST,
  cost_in_app_local_currency: DATA_FIELD_KEYS.COST_IN_LOCAL_CURRENCY,

  calculated_eCPI: DATA_FIELD_KEYS.ECPI,
  calculated_eCPI_in_local_currency: DATA_FIELD_KEYS.ECPI_IN_LOCAL_CURRENCY,
  calculated_eCPC: DATA_FIELD_KEYS.ECPC,
  calculated_eCPM: DATA_FIELD_KEYS.ECPM,
  calculated_eCPM_in_local_currency: DATA_FIELD_KEYS.ECPM_IN_LOCAL_CURRENCY,
  calculated_eCPA_in_local_currency: DATA_FIELD_KEYS.ECPA_IN_LOCAL_CURRENCY,
  calculated_eCPA: DATA_FIELD_KEYS.ECPA,
  calculated_eCPC_in_local_currency: DATA_FIELD_KEYS.ECPC_IN_LOCAL_CURRENCY,
  calculated_ROI: DATA_FIELD_KEYS.ROI,
  calculated_ROAS: DATA_FIELD_KEYS.ROAS,
  eo_click_to_eo_install: DATA_FIELD_KEYS.CLICK_TO_INSTALL,
  eo_click_to_eo_reinstall: DATA_FIELD_KEYS.CLICK_TO_REINSTALL,
  eo_click_to_eo_open: DATA_FIELD_KEYS.CLICK_TO_OPEN,
  eo_click_to_eo_web_session_start: DATA_FIELD_KEYS.CLICK_TO_WEB_SESSION_START,
  impression_conversion_rate: 'impression_conversion_rate',

  [CALCULATION_KEY.AVERAGE_REVENUE]: DATA_FIELD_KEYS.AVERAGE_REVENUE,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_EO_CLICK]: DATA_FIELD_KEYS.VIEW_TO_CLICK,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_EO_INSTALL]: DATA_FIELD_KEYS.VIEW_TO_INSTALL,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_EO_OPEN]: DATA_FIELD_KEYS.VIEW_TO_OPEN,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_EO_DISMISSAL]: DATA_FIELD_KEYS.VIEW_TO_DISMISSAL,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_PURCHASE]: DATA_FIELD_KEYS.VIEW_TO_PURCHASE,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_ADD_TO_CART]: DATA_FIELD_KEYS.VIEW_TO_ADD_TO_CART,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_ADD_TO_WISHLIST]: DATA_FIELD_KEYS.VIEW_TO_ADD_TO_WISHLIST,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_VIEW_CART]: DATA_FIELD_KEYS.VIEW_TO_VIEW_CART,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_INITIATE_PURCHASE]: DATA_FIELD_KEYS.VIEW_TO_INITIATE_PURCHASE,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_ADD_PAYMENT_INFO]: DATA_FIELD_KEYS.VIEW_TO_ADD_PAYMENT_INFO,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_SPEND_CREDITS]: DATA_FIELD_KEYS.VIEW_TO_SPEND_CREDITS,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_RESERVE]: DATA_FIELD_KEYS.VIEW_TO_RESERVE,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_CLICK_AD]: DATA_FIELD_KEYS.VIEW_TO_CLICK_AD,
  [CALCULATION_KEY.EO_BRANCH_CTA_VIEW_TO_VIEW_AD]: DATA_FIELD_KEYS.VIEW_TO_VIEW_AD,

  PURCHASE: DATA_FIELD_KEYS.PURCHASE,
  revenue: DATA_FIELD_KEYS.REVENUE,
  revenue_in_local_currency: DATA_FIELD_KEYS.REVENUE_IN_LOCAL_CURRENCY,
  ADD_TO_CART: DATA_FIELD_KEYS.ADD_TO_CART,
  ADD_TO_WISHLIST: DATA_FIELD_KEYS.ADD_TO_WISHLIST,
  VIEW_CART: DATA_FIELD_KEYS.VIEW_CART,
  INITIATE_PURCHASE: DATA_FIELD_KEYS.INITIATE_PURCHASE,
  ADD_PAYMENT_INFO: DATA_FIELD_KEYS.ADD_PAYMENT_INFO,
  SPEND_CREDITS: DATA_FIELD_KEYS.SPEND_CREDITS,
  RESERVE: DATA_FIELD_KEYS.RESERVE,
  CLICK_AD: DATA_FIELD_KEYS.CLICK_AD,
  VIEW_AD: DATA_FIELD_KEYS.VIEW_AD,

  SEARCH: DATA_FIELD_KEYS.SEARCH,
  VIEW_ITEM: DATA_FIELD_KEYS.VIEW_ITEM,
  VIEW_ITEMS: DATA_FIELD_KEYS.VIEW_ITEMS,
  RATE: DATA_FIELD_KEYS.RATE,
  SHARE: DATA_FIELD_KEYS.SHARE,
  INITIATE_STREAM: DATA_FIELD_KEYS.INITIATE_STREAM,
  COMPLETE_STREAM: DATA_FIELD_KEYS.COMPLETE_STREAM,

  COMPLETE_REGISTRATION: DATA_FIELD_KEYS.COMPLETE_REGISTRATION,
  COMPLETE_TUTORIAL: DATA_FIELD_KEYS.COMPLETE_TUTORIAL,
  ACHIEVE_LEVEL: DATA_FIELD_KEYS.ACHIEVE_LEVEL,
  UNLOCK_ACHIEVEMENT: DATA_FIELD_KEYS.UNLOCK_ACHIEVEMENT,
  INVITE: DATA_FIELD_KEYS.INVITE,
  LOGIN: DATA_FIELD_KEYS.LOGIN,
  SUBSCRIBE: DATA_FIELD_KEYS.SUBSCRIBE,
  UNINSTALL: DATA_FIELD_KEYS.UNINSTALL,
  START_TRIAL: DATA_FIELD_KEYS.START_TRIAL,
  OPT_IN: DATA_FIELD_KEYS.OPT_IN,
  OPT_OUT: DATA_FIELD_KEYS.OPT_OUT,

  [DATA_FIELD_KEYS.CLICK_TO_IMPRESSION]: DATA_FIELD_KEYS.CLICK_TO_IMPRESSION,
};

export const SERVER_CUSTOM_EVENT_PREFIX = 'custom_event__';

export const CUSTOM_EVENT_PREFIX = 'eo_custom_event-';

export const BLOCKED_CUSTOM_EVENT_PREFIX = 'eo_custom_event_blocked-';
